import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import {
    FETCH_ACTIVATING_ORGS,
    FETCH_ACTIVATING_ORGS_SUCCESS,
} from '../../constants';

const fetchActivatingOrgs = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_ACTIVATING_ORGS),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.poiServer}/report-permissions/get-tracking-orgs/${action.clientId}`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.token}`,
          'Content-Type': 'application/json',
        },
        responseType: 'json',
        crossDomain: true,
        method: 'GET',
      }).pipe(
        map(response => {
          return {
            type: FETCH_ACTIVATING_ORGS_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>{
            console.log(error)
        }
        )
      )

    )
  );

export default fetchActivatingOrgs;
